/* BebeLux Blog-Grundschema, 2026-09-07.
   Reine Verbesserung: ohne dieses Skript bleibt der Artikel vollstaendig
   bedienbar. Die FAQ stehen im Markup auf "open", damit sie ohne JavaScript
   lesbar sind; hier werden sie zugeklappt, sobald Skripte laufen. */
(function () {
  'use strict';

  function collapseFaq() {
    var items = document.querySelectorAll('.bba-faq__item[open]');
    for (var i = 0; i < items.length; i++) {
      items[i].removeAttribute('open');
    }
  }

  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var field = document.createElement('textarea');
      field.value = text;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.top = '-1000px';
      document.body.appendChild(field);
      field.select();
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (err) {
        ok = false;
      }
      document.body.removeChild(field);
      if (ok) {
        resolve();
      } else {
        reject();
      }
    });
  }

  function bindCopy() {
    var button = document.querySelector('[data-bba-copy]');
    if (!button) return;

    button.addEventListener('click', function () {
      var url = button.getAttribute('data-url') || window.location.href;
      var original = button.textContent;
      copyToClipboard(url).then(
        function () {
          button.textContent = button.getAttribute('data-copied') || original;
          button.classList.add('bba-share__done');
          window.setTimeout(function () {
            button.textContent = original;
            button.classList.remove('bba-share__done');
          }, 2000);
        },
        function () {
          /* Kopieren nicht moeglich: Beschriftung bleibt unveraendert,
             der Nutzer kann die Adresszeile verwenden. */
        }
      );
    });
  }


  /* Nur tatsaechlich breite Tabellen als tastaturbedienbare Scrollregionen.
     Ohne JavaScript bleiben die serverseitigen Wrapper ebenfalls scrollbar. */
  function tableScrollRegions() {
    var wrappers = document.querySelectorAll('.bba-tablewrap');
    for (var i = 0; i < wrappers.length; i++) {
      (function (wrapper) {
        var table = wrapper.querySelector('table');
        var hint = wrapper.previousElementSibling;
        function update() {
          var overflowing = wrapper.scrollWidth > wrapper.clientWidth + 1;
          wrapper.tabIndex = overflowing ? 0 : -1;
          if (hint && hint.classList.contains('bba-tablehint')) hint.hidden = !overflowing;
        }
        update();
        if (window.ResizeObserver) {
          var observer = new ResizeObserver(update);
          observer.observe(wrapper);
          if (table) observer.observe(table);
        } else {
          window.addEventListener('resize', update, { passive: true });
        }
      })(wrappers[i]);
    }
  }

  /* Scroll-Spy fuer das Inhaltsverzeichnis in der klebenden Seitenleiste.
     Laeuft nur ab 1200 px, weil es die Seitenleiste erst dort gibt; auf dem
     Telefon bleibt das Inhaltsverzeichnis unveraendert. Ohne
     IntersectionObserver passiert nichts, die Sprungmarken funktionieren
     trotzdem. */
  function inhaltsSpion() {
    var abfrage = window.matchMedia('(min-width: 1200px)');
    var links = document.querySelectorAll('.bba-side .bba-toc__link');
    if (!links.length || !window.IntersectionObserver) return;

    var paare = [];
    for (var i = 0; i < links.length; i++) {
      var id = (links[i].getAttribute('href') || '').replace('#', '');
      var ziel = id ? document.getElementById(id) : null;
      if (ziel) paare.push({ link: links[i], ziel: ziel });
    }
    if (!paare.length) return;

    /* Abstand von oben: klebender Kopf 68 px plus 24 px Luft, derselbe Wert
       wie das top der Seitenleiste im CSS. */
    var KOPF = 92;
    var beobachter = null;
    var aktiv = null;

    function setze(eintrag) {
      if (eintrag === aktiv) return;
      if (aktiv) {
        aktiv.link.classList.remove('is-active');
        aktiv.link.removeAttribute('aria-current');
      }
      aktiv = eintrag;
      if (aktiv) {
        aktiv.link.classList.add('is-active');
        aktiv.link.setAttribute('aria-current', 'true');
      }
    }

    function pruefe() {
      /* Der aktive Abschnitt ist der letzte, dessen Ueberschrift bereits
         oberhalb der Kopfkante steht. Steht noch keiner dort, ist es der
         erste. */
      var treffer = null;
      for (var i = 0; i < paare.length; i++) {
        if (paare[i].ziel.getBoundingClientRect().top - KOPF - 8 <= 0) {
          treffer = paare[i];
        }
      }
      if (!treffer) treffer = paare[0];
      setze(treffer);
    }

    function an() {
      if (beobachter) return;
      beobachter = new IntersectionObserver(pruefe, {
        rootMargin: '-' + KOPF + 'px 0px 0px 0px',
        threshold: [0, 1]
      });
      for (var i = 0; i < paare.length; i++) beobachter.observe(paare[i].ziel);
      window.addEventListener('scroll', pruefe, { passive: true });
      pruefe();
    }

    function aus() {
      if (!beobachter) return;
      beobachter.disconnect();
      beobachter = null;
      window.removeEventListener('scroll', pruefe);
      setze(null);
    }

    function schalte() {
      if (abfrage.matches) { an(); } else { aus(); }
    }

    schalte();
    if (abfrage.addEventListener) {
      abfrage.addEventListener('change', schalte);
    } else if (abfrage.addListener) {
      abfrage.addListener(schalte);
    }
  }

  function init() {
    collapseFaq();
    bindCopy();
    tableScrollRegions();
    inhaltsSpion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
